export function trackerConfigDrawerWavesExcludeExceedsCountMessage(
  numberOfWaves: number,
): string {
  return `Excluded waves can't exceed the total number of waves (currently ${numberOfWaves}).`;
}

export function trackerConfigDrawerWavesExcludeHelpText(
  numberOfWaves: number,
): string {
  return `Max: ${numberOfWaves} waves based on the amount of waves set up above.`;
}
